// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 此处后端没有提供注释 POST /api/app/flowapprove/getpagemodulelist_application */
export async function postAppFlowApproveGetPageModuleListApplication(
  body: API.ModuleListQueryDto,
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(
    '/api/app/flowapprove/getpagemodulelist_application',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 此处后端没有提供注释 POST /api/app/flowapprove/getpagemodulelist_waitaudit */
export async function postAppFlowApproveGetPageModuleListWaitaudit(
  body: API.ModuleListQueryDto,
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(
    '/api/app/flowapprove/getpagemodulelist_waitaudit',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 此处后端没有提供注释 POST /api/app/flowapprove/getmodulelistbyid_application */
export async function postAppFlowApproveGetModuleListByIdApplication(
  params: {
    id?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(
    '/api/app/flowapprove/getmodulelistbyid_application',
    {
      method: 'POST',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 根据订单 BOM 行上下文获取各状态 Module List POST /api/app/flowapprove/getmodulelistbyorder */
export async function postAppFlowApproveGetModuleListByOrder(
  body: {
    sO_Item?: string;
    item?: string;
    bomLevel?: string;
    bomItem?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(
    '/api/app/flowapprove/getmodulelistbyorder',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 此处后端没有提供注释 POST /api/app/flowapprove/updateapproveuser_application */
export async function postAppFlowApproveUpdateApproveUserApplication(
  body: any,
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(
    '/api/app/flowapprove/updateapproveuser_application',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 此处后端没有提供注释 GET /api/flowapprove/combinations */
export async function getFlowapproveCombinations(
  params?: {
    expression?: string;
  },
  options?: { [key: string]: any },
) {
  return request<string[]>('/api/flowapprove/combinations', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/flowapprove/minimalcombinations */
export async function getFlowapproveMinimalcombinations(
  params?: {
    expression?: string;
  },
  options?: { [key: string]: any },
) {
  return request<string[]>('/api/flowapprove/minimalcombinations', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/flowapprove/modulelistchangecontent */
export async function getFlowapproveModulelistchangecontent(
  params?: {
    Id?: number;
    VersionRelateId?: number;
    FlowRelateId?: number;
    MachineType?: string;
    Material?: string;
    ProductType?: string;
    BaseHight?: string;
    PolePairs?: string;
    BaseLength?: string;
    CoreLength?: string;
    RotationalSpeed?: string;
    BaseType?: string;
    Voltage?: string;
    ProductGen?: string;
    CN?: string;
    SalesRegion?: string;
    VCCombination?: string;
    NoteKeywords?: string;
    MaterialType?: string;
    MaterialNo?: string;
    MaterialDesc?: string;
    OperatingMode?: string;
    Qty?: number;
    MaterialTypeUp?: string;
    Is_vmodule?: boolean;
    Remark?: string;
    ProductCode?: string;
    ProductModel?: string;
    CheckUser?: string;
    ChangeType?: string;
    ChangeContent?: string;
    DataSource?: string;
    SO_Item?: string;
    ApplicationRemark?: string;
    ConflictSign?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(
    '/api/flowapprove/modulelistchangecontent',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

export async function postAppModuleListGetModuleListByIdApplication(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: {},
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(
    '/api/app/FlowApprove/GetModuleListById_Application',
    {
      method: 'POST',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 此处后端没有提供注释 POST /api/app/flowapprove/deletemodulelist_application */
export async function postAppFlowApproveDeleteModuleListApplication(
  body: number[],
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(
    '/api/app/flowapprove/deletemodulelist_application',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 此处后端没有提供注释 POST /api/app/flowapprove/submitmodulelist_application */
export async function postAppFlowApproveSubmitModuleListApplication(
  body: any,
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(
    '/api/app/flowapprove/submitmodulelist_application',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 此处后端没有提供注释 POST /api/app/flowapprove/batchsubmitmodulelist_application */
export async function postAppFlowApproveBatchSubmitModuleListApplication(
  body: number[],
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(
    '/api/app/flowapprove/batchsubmitmodulelist_application',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 我的申请-批量提交Module List到待审批（勾选全部） POST /api/app/flowapprove/batchsubmitmodulelist_application_all */
export async function postAppFlowApproveBatchSubmitModuleListApplicationAll(
  body: API.ModuleListQueryDto,
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(
    '/api/app/flowapprove/batchsubmitmodulelist_application_all',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 此处后端没有提供注释 POST /api/app/flowapprove/revokemodulelist_application */
export async function postAppFlowApproveRevokeModuleListApplication(
  body: number[],
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(
    '/api/app/flowapprove/revokemodulelist_application',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 我的申请-批量撤回待审批的ModuleList（勾选全部） POST /api/app/flowapprove/revokemodulelist_application_all */
export async function postAppFlowApproveRevokeModuleListApplicationAll(
  body: API.ModuleListQueryDto,
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(
    '/api/app/flowapprove/revokemodulelist_application_all',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 我的申请、待审批-批量修改Module List审批人（勾选全部） POST /api/app/flowapprove/updateapproveuser_application_all */
export async function postAppFlowApproveUpdateApproveUserApplicationAll(
  body: API.ModuleListQueryDto,
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(
    '/api/app/flowapprove/updateapproveuser_application_all',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 此处后端没有提供注释 POST /api/app/flowapprove/updatecreatemodulelist_application */
export async function postAppFlowApproveUpdatecreatemodulelistApplication(
  body: any,
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(
    '/api/app/flowapprove/updatecreatemodulelist_application',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/**待审批-查询待审批列表 */
export async function getPageModuleListWaitAudit(
  body: any,
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(
    '/api/app/flowapprove/getpagemodulelist_waitaudit',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}
/**待审批-根据主键Id获取待审批的Module List*/
export async function getModuleListByIdWaitAudit(
  params: any,
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(
    '/api/app/flowapprove/getmodulelistbyid_waitaudit',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      params,
      ...(options || {}),
    },
  );
}
/**待审批-审批通过Module List*/
export async function approveModuleListWaitAudit(
  body: any,
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(
    '/api/app/flowapprove/approvemodulelist_waitaudit',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}
/**待审批-批量审批通过Module List*/
export async function batchApproveModuleListWaitAudit(
  body: any,
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(
    '/api/app/flowapprove/batchapprovemodulelist_waitaudit',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}
/**待审批-批量拒绝Module List*/
export async function rejectModuleListWaitAudit(
  body: any,
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(
    '/api/app/flowapprove/rejectmodulelist_waitaudit',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 待审批-批量审批通过Module List（勾选全部） POST /api/app/flowapprove/batchapprovemodulelist_waitaudit_all */
export async function batchApproveModuleListWaitAuditAll(
  body: API.ModuleListQueryDto,
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(
    '/api/app/flowapprove/batchapprovemodulelist_waitaudit_all',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 待审批-批量拒绝待审批的ModuleList（勾选全部） POST /api/app/flowapprove/rejectmodulelist_waitaudit_all */
export async function rejectModuleListWaitAuditAll(
  body: API.ModuleListQueryDto,
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(
    '/api/app/flowapprove/rejectmodulelist_waitaudit_all',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/**待审批-导出Module List*/
export async function exportModuleListWaitAudit(
  body: any,
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(
    '/api/app/flowapprove/exportmodulelist_waitaudit',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/**待审批-刷新审批Module List*/
export async function refreshApproveModuleListWaitAudit(
  body: any,
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(
    '/api/app/flowapprove/refreshapprovemodulelist_waitaudit',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}
